<template>
  <QuestionBase
      :question="question" :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
      :valid="!!data"
      :disabled-valid="false"
  >
    <InputBasic
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        :noSave="noSave"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'SharedOwnershipPercentage',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: Number,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    },
    question() {
      return {
        title: `${this.type === 'Remortgage' ? 'What percentage of the property will you own after the remortgage completes?' : 'What percentage of the property would you be purchasing?'}`,
        subTitle: null,
        tip: null,
      }
    },
  },
  data () {
    return {
      db: {
        saveLocation: 'mortgage_survey_save',
        saveField: 'new_shared_percentage',
        objectId: this.objectId
      },
      args: {
        placeholder: 'e.g. 75',
        label: null,
        type: 'number',
        skippable: true,
        required: true,
        inputClass: 'field-50',
        appendText: '%'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>